import { render, staticRenderFns } from "./formularioComponent.vue?vue&type=template&id=e53a3554"
import script from "./formularioComponent.vue?vue&type=script&lang=js"
export * from "./formularioComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports